<template>
  <v-form ref="form" v-model="valid" lazy-validation @close="close" @submit="submit" @submit.prevent="save">
    <v-card class="border">
      <v-card-title style="display: contents">
        <v-card class="card-header" style="box-shadow: none;">
          <span :class="{ 'text-h5' : !isDisplaySmall }">{{ message }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                right
                class="btn__icon pa-0"
                style="position: absolute; right: 15px; height: 50%"
                width="18"
                @click="close"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card>
      </v-card-title>

      <v-card class="card-icon" v-if="!isDisplaySmall">
        <v-icon class="custom-icon" color="white">{{ icon }}</v-icon>
      </v-card>

      <v-card-text>
        <v-container>
          <v-row style="display: block; margin-left: 10%; margin-right: 10%">
            <v-col cols="12" class="pb-0">
              <v-text-field
                v-model="formatPhoneNumberContent"
                prepend-inner-icon="mdi-phone"
                outlined
                dense
                disabled
                flat
                label="Номер телефона абонента"
                class="mb-0"
              />
            </v-col>
            <v-row class="mb-1 mt-1">
              <v-col :cols="12" :md="4" class="pb-0 pt-0">
                <v-text-field
                  v-model="attPopupEditContent.surname"
                  prepend-inner-icon="mdi-account-outline"
                  outlined
                  dense
                  flat
                  label="Фамилия"
                  class="mb-0"
                  required
                />
              </v-col>
              <v-col :cols="12" :md="4" class="pb-0 pt-0">
                <v-text-field
                  v-model="attPopupEditContent.name"
                  prepend-inner-icon="mdi-account-outline"
                  outlined
                  dense
                  flat
                  label="Имя"
                  class="mb-0"
                  required
                />
              </v-col>
              <v-col :cols="12" :md="4" class="pb-0 pt-0">
                <v-text-field
                  v-model="attPopupEditContent.patronymic"
                  prepend-inner-icon="mdi-account-outline"
                  outlined
                  dense
                  flat
                  label="Отчество"
                  class="mb-0"
                  required
                />
              </v-col>
            </v-row>
            <v-col cols="12" class="pb-0 pt-0">
              <v-text-field
                v-model.trim="attPopupEditContent.comment"
                prepend-inner-icon="mdi-comment-processing-outline"
                outlined
                dense
                flat
                required
                class="mb-0 mt-0"
                label="Комментарий"
              />
            </v-col>
            <div style="display: block; text-align: center;">
              <v-btn
                outlined
                class="text-none mb-2 px-2 btn-code"
                rounded
                dark
                :loading="isBtnLoading"
                :disabled="!valid"
                @click="save"
              >
                Сохранить
              </v-btn>
            </div>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="pt-0" style="display: contents">
        <v-card class="card-footer-dialog">
          <div style="display: grid; grid-template-columns: 10% 1fr;" class="pr-8 pb-3">
            <div>
              <v-icon style="font-size: 50px;" color="#87A1B9">mdi-information-outline</v-icon>
            </div>
            <div style="text-align: justify; font-family: Arial, sans-serif;">
              <p><strong>Редактирование абонента</strong></p>
              <p class="mb-0 mt-2">
                Здесь можно изменить фамилию, имя, отчество и комментарий абонента. Номер телефона отображается только для справки и не редактируется.
              </p>
            </div>
          </div>
        </v-card>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import formatPhoneNumber from '../mixins/formatPhoneNumber';
import { mapActions } from 'vuex';

export default {
  mixins: [formatPhoneNumber],
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
    },
    message: {
      type: String,
    },
    icon: {
      type: String,
    },
    responseCars: {
      type: Array,
    },
    attPopupEditContent: {
      type: Object,
      default: () => ({
        name: '',
        surname: '',
        patronymic: '',
        car_number: [],
        comment: this.item.comment || '',
      }),
    },
  },
  data: () => ({
    valid: true,
    filterAbonents: {},
    abonentTelephone: '',
    isBtnLoading: false,
    isDisplaySmall: false,
  }),
  created () {
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  computed: {
    formatPhoneNumberContent () {
      const phoneNumber = this.attPopupEditContent.telephone.toString();
      const digits = phoneNumber.replace(/\D/g, '');
      return `+${digits.slice(0, 1)} (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
    },
  },
  methods: {
    ...mapActions({
      simpleUpdateAbonent: 'Abonents/simpleUpdateAbonent',
      loadTemporaryAbonents: 'TemporaryAbonent/loadTemporaryAbonents',
    }),
    checkSize () {
      this.isDisplaySmall = window.innerWidth <= 800;
    },
    save () {
      this.$refs.form.validate();
      this.$nextTick(async () => {
        if (this.valid) {
          const dataManagement = {
            name: this.attPopupEditContent.name,
            surname: this.attPopupEditContent.surname,
            patronymic: this.attPopupEditContent.patronymic,
            comment: this.attPopupEditContent.comment,
            car_number: this.attPopupEditContent.car_number,
          };
          try {
            this.isBtnLoading = true;
            await this.close();
            this.updateAbonentData(dataManagement);
          } catch (error) {
            console.error(error);
            this.$flash_warning('Ошибка при сохранении данных абонента.');
          } finally {
            this.isBtnLoading = false;
          }
        }
      });
    },
    updateAbonentData (dataManagement) {
      this.simpleUpdateAbonent({
        idAbonent: this.id,
        dataAbonent: dataManagement,
      })
        .then(() => {
          this.submit();
          this.$flash_success('Изменения успешно сохранены!');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при редактировании абонента');
        });
    },
    async submit () {
      await this.$emit('submit');
    },
    async close () {
      await this.$emit('close');
      this.$emit('update:active', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.card-completion {
  display: flex;
}
.card-info {
  background-color: rgba(248, 248, 248, 0.35);
  color: black;
  width: auto;
  box-shadow: none;
}
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.custom-icon {
  font-size: 45px;
  height: 100%;
}
.card-icon {
  border-radius: 16px;
  top: 0;
  left: 0;
  position: absolute;
  width: 11%;
  height: 88px;
  max-height: 88px;
  text-align: center;
  background-color: #E0B389;
}
.card-footer-dialog {
  border-radius: 16px;
  text-align: center;
  padding-top: 10px;
  min-height: 100px;
  width: 100%;
  box-shadow: none;
  background-color: rgba(224, 179, 137, 0.5);
}
.btn-code {
  width: 100%;
  max-width: 250px;
  background-color: #E0B389;
  color: white;
}
.v-application p {
  margin-bottom: 0;
  font-family: 'Montserrat', sans-serif;
}
.box-2 {
  grid-column: 1 / 3;
}
.box-3 {
  grid-column: 1 / 3;
  grid-row: 4 / 5;
}
.border {
  border-radius: 16px;
}
.intercom-label {
  font-weight: 600;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
}
.intercom-info {
  padding-left: 15px;
  font-weight: 400 !important;
  font-size: 14px;
  word-wrap: break-word;
  font-family: 'Montserrat', sans-serif;
}
.text-info {
  font-size: 15px;
}
@media screen and (max-width: 800px) {
  .card-header {
    margin-bottom: 30px;
  }
  .grid-container {
    display: block;
  }
  .card-completion {
    display: block;
  }
  .text-info {
    padding: 20px;
  }
}
@media screen and (max-width: 500px) {
  .code-designation {
    display: none;
  }
  v-card-title {
    padding: 0;
  }
}
@media screen and (max-width: 350px) {
  .v-text-field-like {
    width: 210px;
  }
}
</style>
